export const RANGE_SELECTED = {
    startDate: null,
    endDate: null
}